export const WEBSITE_LANGUAGE_GETALL = 'WEBSITE_LANGUAGE_GETALL'
